import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.productsLabel',
    messageKey: 'chatbot.suggestions.products',
  },
  {
    id: 'certifications',
    labelKey: 'chatbot.suggestions.certificationsLabel',
    messageKey: 'chatbot.suggestions.certifications',
  },
  {
    id: 'contact',
    labelKey: 'chatbot.suggestions.contactLabel',
    messageKey: 'chatbot.suggestions.contact',
  },
]

export const contactCTAs: ContactCTA[] = [
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'sales@pel.it',
  },
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 030 8936011',
  },
]
